<template>
  <div>
    <ag-dropdown
      :options="options"
      text="Export"
      @onChangeDropdown="onChange"
    />
  </div>
</template>

<script>
import Papa from "papaparse";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import AgDropdown from "@/components/ag-dropdown";
import { useStore } from "@/store";
import { GeneralActionTypes } from "../../store/modules/general/action-types";
import { mapState, mapActions, mapGetters } from "vuex";

const store = useStore();

export default {
  props: {
    data: {
      type: Array,
    },
    fileName: {
      type: String,
      default: "Export",
    },
    type: {
      type: String,
      default: "csv",
    },
    headers: {
      type: Array,
    },
    tableName: {
      type: String,
      default: "#exportable-table",
    },
    columns: {
      type: Array,
      default: null,
    },
  },
  components: {
    AgDropdown,
  },
  data() {
    return {
      options: [
        { value: "csv", label: "Export CSV" },
        { value: "pdf", label: "Export PDF" },
      ],
    };
  },
  computed: {
    exportDataLoaded() {
      return store.state.general.exportDataLoaded;
    },
    exportStatus() {
      return store.state.general.exportStatus;
    },
  },
  watch: {
    exportDataLoaded(data) {
      if (data && this.exportStatus == "pdf") {
        const doc = new jsPDF({
          orientation: "landscape",
        });

        doc.autoTable({
          html: this.tableName,
          includeHiddenHtml: true,
          styles: {
            fontSize: 8,
            minCellWidth: 20,
          },
          headStyles: {
            overflow: "ellipsize",
          },
        });
        doc.save(`${moment().format("DD_MM_YYYY")}_${this.fileName}.pdf`);
        store.dispatch(GeneralActionTypes.SET_EXPORT_STATUS, false);
        store.dispatch(GeneralActionTypes.SET_EXPORT_DATA_LOADED, false);
        this.$emit("exportend");
      } else if (data && this.exportStatus == "csv") {
        var blob = new Blob(
          [
            Papa.unparse(this.data, {
              header: true,
              columns: this.columns
                .filter((f) => f.excelField)
                .map((m) => m.excelField),
            }),
          ],
          {
            type: "text/csv;charset=utf-8;",
          }
        );

        var link = document.createElement("a");

        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute(
          "download",
          `${moment().format("DD_MM_YYYY")}_${this.fileName}.csv`
        );
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        store.dispatch(GeneralActionTypes.SET_EXPORT_STATUS, false);
        store.dispatch(GeneralActionTypes.SET_EXPORT_DATA_LOADED, false);
        this.$emit("exportend");
      }
    },
  },
  methods: {
    onChange(data) {
      if (data.value == "csv") this.exportCSV();
      if (data.value == "pdf") this.exportPDF();
    },
    exportCSV() {
      store.dispatch(GeneralActionTypes.SET_EXPORT_DATA_LOADED, false);
      store.dispatch(GeneralActionTypes.SET_EXPORT_STATUS, "csv");
      this.$emit("exportstart");
    },
    exportPDF() {
      store.dispatch(GeneralActionTypes.SET_EXPORT_DATA_LOADED, false);
      store.dispatch(GeneralActionTypes.SET_EXPORT_STATUS, "pdf");
      this.$emit("exportstart");
    },
  },
};
</script>

<style lang="scss" scoped></style>
